import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom'; // for dynamic routes
import { getEventBySlugFromStorage, createEventSlug, isEventOver } from '../../utils/urlUtils';
import { combineDateAndTime, formatEventDateTimeFromAPI } from '../../utils/timeUtils';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import './EventDetailPage.css'; // optional for custom styles
import eventImg1 from '../../assets/images/events/eventdetail-1.png';
import eventImg2 from '../../assets/images/events/gm-1.jpg';
import eventImg3 from '../../assets/images/events/gm-2.webp';
import shah from '../../assets/images/shah sponser.jpeg';
import adam from '../../assets/images/adam.jpeg';
import bigbrix from '../../assets/images/bigbrix.jpeg';
import cs from '../../assets/images/cs.jpeg';
import gsl from '../../assets/images/gsl.jpg';
import green from '../../assets/images/green-stop.jpeg';
import legend from '../../assets/images/legend.jpeg';
import prabaLogo from '../../assets/images/praba-logo.jpg';
import prabhavisiting from '../../assets/images/prabha-visiting.jpeg';
import wl from '../../assets/images/wl.jpeg';

import lifespon from '../../assets/images/life-sponsor.jpeg';
import prananyanilaimg from '../../assets/images/PRANAYANILA-deatilpage-img.png';
import eventBannerBg from '../../assets/images/events/eventdetail-blur.png';
import calendarIcon from '../../assets/images/icons/white-calendar.svg';
import locationIcon from '../../assets/images/icons/white-location.svg';
import photoGalleryIcon from '../../assets/images/icons/photo-gallery.svg';
import hourglass from '../../assets/images/icons/hourglass-icon.svg';
import profileIcon from '../../assets/images/icons/person-icon.svg';  
import pawicon from '../../assets/images/icons/paw-icon.svg';
import pinkLocation from '../../assets/images/icons/pink-location-icon.svg';
import EventsSection from '../../components/eventCards/EventsSection';
import layourImg from '../../assets/images/events/event-layout.png';
import event2 from '../../assets/images/events/event-2.png';
import mcubeBanner1 from '../../assets/images/events/muthukad-event-banner-3.jpg';
import fiestaBanner1 from '../../assets/images/events/Kairali-uk-poster-new.png';
import eventVideo from '../../assets/images/events/Kairali-uk-video.mp4';
import { getEventById, getEvents } from '../../services/apiService';
import NotFound404 from '../../components/404Page/NotFound404';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'; 

// Utility function to safely format dates



const formatEventDateTime = (datetime) => {
  try {
    const eventDate = new Date(datetime);
    if (isNaN(eventDate.getTime())) {
      return 'Date not available';
    }
    
    // Format date
    const dateStr = eventDate.toLocaleDateString();
    
    // Format time in 12-hour format with AM/PM
    const timeStr = eventDate.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
    
    return `${dateStr} • ${timeStr}`;
  } catch (error) {
    return 'Date not available';
  }
};

// Utility function to strip HTML tags and get plain text (for banner preview)
const stripHtmlTags = (html) => {
  if (!html) return "";
  // Replace HTML tags with spaces to preserve spacing between text nodes
  const textWithSpaces = html.replace(/<[^>]*>/g, ' ');
  // Create a temporary div to decode HTML entities and get clean text
  const tmp = document.createElement("DIV");
  tmp.innerHTML = textWithSpaces;
  const text = tmp.textContent || tmp.innerText || "";
  // Normalize whitespace: replace multiple spaces/newlines with single space, then trim
  return text.replace(/\s+/g, ' ').trim();
};

// Utility function to truncate text
const truncateText = (text, maxLength = 150) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + "...";
};

const formatDescription = (desc) => {
  if (!desc) return null;
  
  // Check if description contains HTML tags
  const hasHtml = /<[a-z][\s\S]*>/i.test(desc);
  
  if (hasHtml) {
    // Render HTML description
    return (
      <div 
        className="event-description-html"
        dangerouslySetInnerHTML={{ __html: desc }}
        style={{ lineHeight: '1.6' }}
      />
    );
  } else {
    // Fallback to plain text formatting for backwards compatibility
    return desc.split(/\n\n+/).map((para, idx) => (
      <p key={idx} style={{ whiteSpace: 'pre-line', marginBottom: '1.2em' }}>
        {para.split('\n').map((line, i, arr) =>
          i < arr.length - 1 ? <React.Fragment key={i}>{line}<br /></React.Fragment> : line
        )}
      </p>
    ));
  }
};

const formatEventDate = (datetime) => {
  try {
    const eventDate = new Date(datetime);
    if (isNaN(eventDate.getTime())) {
      return 'Date not available';
    }
    return eventDate.toLocaleString();
  } catch (error) {
    return 'Date not available';
  }
};

// Helper function to get event banner image based on event title
const getEventBanner = (eventTitle) => {
  const title = eventTitle?.toLowerCase() || '';
  if (title.includes('mcube') || title.includes('magic') || title.includes('melody') || title.includes('mission')) {
    return mcubeBanner1;
  }
  else if(title.includes('pranayanila') || title.includes('pranayanila 2.0')){
    return prananyanilaimg;
  }
  else if (title.includes('fiesta') || title.includes('xmas') || title.includes('new year') || title.includes('celebration')) {
    return fiestaBanner1;
  }
  // Default fallback
  return eventImg1;
};
const showSponsors = (eventTitle) => {
  const title = eventTitle?.toLowerCase() || '';
  return title.includes('pranayanila');
};

// Helper function to check if event is Fiesta
const isFiestaEvent = (eventTitle) => {
  const title = eventTitle?.toLowerCase() || '';
  return title.includes('fiesta') || title.includes('xmas') || title.includes('new year') || title.includes('celebration');
};

// const mockEventList = [
//   {
//     id: "music-night",
//     title: "Music Night with Star Artist",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Curabitur pretium tincidunt lacus. Nulla gravida orci a odio.",
//     datetime: "2025-04-12T19:00:00Z",
//     venue: {
//       name: "Abcd Auditorium, London",
//       address: "1234 Elm Street, Springfield, Anytown, USA 12345",
//       map_url: "https://maps.google.com/",
//     },
//     images: [
//      eventImg1,
//       eventImg2,
//       eventImg3,
//     ],
//     galleryCount: 5,
//     duration: "3 hours",
//     ageLimit: "5 years & above",
//     petFriendly: false,
//     ticketPrices: {
//       Bronze: 100,
//       Silver: 200,
//       "Fan Pit": 500,
//     },
//     layoutImage: layourImg,
//   },
//   {
//     id: "683576c5576c66d3d2841e04",
//     title: "Jazz Evening with Legendary Saxophonist",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Curabitur pretium tincidunt lacus. Nulla gravida orci a odio.",
//     datetime: "2025-05-20T20:00:00Z",
//     venue: {
//       name: "Blue Note Hall, New York",
//       address: "5678 Broadway Avenue, New York, NY 10001, USA",
//       map_url: "https://maps.google.com/",
//     },
//     images: [
//       eventBanner1,
//       eventBanner1,
//       eventBanner1,
//     ],
//     galleryCount: 8,
//     duration: "2.5 hours",
//     ageLimit: "10 years & above",
//     petFriendly: true,
//     ticketPrices: {
//       Bronze: 120,
//       Silver: 250,
//       "Fan Pit": 550,
//     },
//     layoutImage: layourImg,
//   }
// ];


const EventDetailPage = () => {
  const { eventName } = useParams(); // dynamic route param
  const [eventData, setEventData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);

   const galleryRef = useRef(null);
  const videoRef = useRef(null);

  const openGallery = () => {
    galleryRef.current?.openGallery(0);
  };

  // Ensure video autoplays when loaded (only for Fiesta events)
  useEffect(() => {
    if (eventData && isFiestaEvent(eventData.title) && videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log('Video autoplay prevented:', error);
      });
    }
  }, [eventData]);

  // Handle modal backdrop when showContactModal changes
  useEffect(() => {
    if (showContactModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      // Clean up any stray backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
    }
  }, [showContactModal]);


//   useEffect(() => {

//     const fetchEvent = async () => {
//   try {
//     // Simulating an API call to fetch event details
//     const response = await getEventById(eventId);
//     if (response.status === 200 || response.status === 201) {
//       console.log("Event data fetched successfully:", response.data);
//       // setEventData(response.data);
//     } else {
//       console.error("Error fetching event data:", response);
//       setEventData(null);
//     }
//   } catch (error) {
//     console.error("Error fetching event data:", error);
//     setEventData(null);
//   }
// };
//     fetchEvent();

//   const data = mockEventList.find(event => event.id === eventId);
//   setEventData(data);
// }, [eventId]);


  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        // First try to get event from storage by slug
        let eventFromStorage = getEventBySlugFromStorage(eventName);
        if (eventFromStorage) {
          console.log("Found event in storage:", eventFromStorage);
          
          // Transform the storage data to match expected structure
          // Handle datetime properly using utility function
          const datetime = combineDateAndTime(eventFromStorage.date, eventFromStorage.time);
          
          const transformedStorageData = {
            id: eventFromStorage._id,
            title: eventFromStorage.title,
            description: eventFromStorage.description,
            datetime: datetime,
            date: eventFromStorage.date, // Preserve original date
            time: eventFromStorage.time, // Preserve original time
            venue: {
              name: eventFromStorage.venue || "N/A",
              address: eventFromStorage.address || "N/A",
              map_url: eventFromStorage.map,
            },
            images: [
              getEventBanner(eventFromStorage.title),
              eventImg2,
              eventImg3,
            ],
            galleryCount: 3,
            duration: eventFromStorage.duration || "N/A",
            ageLimit: eventFromStorage.ageGroup || "N/A",
            petFriendly: eventFromStorage.pet, 
            ticketPrices: {
              Bronze: 100, 
              Silver: 200,
              "Fan Pit": 500,
            },
            layoutImage: null, 
            seatingPlan: eventFromStorage.seatingPlan
          };
          
          setEventData(transformedStorageData);
          setIsLoading(false);
          return;
        }
        
        // If not found in storage, fetch all events and find by slug (fallback for direct URL access)
        console.log("Event not found in storage, fetching all events...");
        const eventsResponse = await getEvents();
        console.log("Events API Response:", eventsResponse);
        
        if (eventsResponse && eventsResponse.data) {
          // Find the event that matches the slug - check both API slug and generated slug
          const matchingEvent = eventsResponse.data.find(event => {
            const apiSlug = event.slug;
            const generatedSlug = createEventSlug(event.title);
            return apiSlug === eventName || generatedSlug === eventName;
          });
          
          if (matchingEvent) {
            console.log("Found matching event:", matchingEvent);
            // Store it in sessionStorage for future use
            sessionStorage.setItem(`event_${eventName}`, JSON.stringify(matchingEvent));
            
            const response = matchingEvent;
            const data = response;
            
            // Handle datetime properly using utility function
            const datetime = combineDateAndTime(data.date, data.time);

            const transformed = {
              id: data._id,
              title: data.title,
              description: data.description,
              datetime: datetime,
              date: data.date, // Preserve original date
              time: data.time, // Preserve original time
              venue: {
                name: data.venue || "N/A",
                address: data.address || "N/A",
                map_url: data.map,
              },
              images: [
                getEventBanner(data.title),
                eventImg2,
                eventImg3,
              ],
              galleryCount: 3,
              duration: data.duration || "N/A",
              ageLimit: data.ageGroup || "N/A",
              petFriendly: data.pet, 
              ticketPrices: {
                Bronze: 100, 
                Silver: 200,
                "Fan Pit": 500,
              },
              layoutImage: null, 
              seatingPlan: data.seatingPlan
            };

            setEventData(transformed);
          } else {
            console.error("No matching event found for slug:", eventName);
            setError("Event not found");
          }
        } else {
          console.error("Failed to fetch events from API");
          setError("Failed to load events");
        }
      } catch (error) {
        console.error("API fetch failed:", error);
        setError("Failed to load event");
      } finally {
        setIsLoading(false);
      }
    };

    if (eventName) fetchEvent();
  }, [eventName]);

  // Show loading state while fetching data
  if (isLoading) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading event details...</p>
          </div>
        </div>
      </div>
    );
  }

  // Show error state
  if (error || !eventData) {
    return <NotFound404 />;
  }

  const {
    title,
    description,
    datetime,
    venue,
    images,
    galleryCount,
    duration,
    ageLimit,
    petFriendly,
    ticketPrices,
    layoutImage,
    seatingPlan
  } = eventData;

  // Ensure venue is properly structured to prevent rendering errors
  const safeVenue = venue && typeof venue === 'object' ? venue : {
    name: venue || "N/A",
    address: "N/A", 
    map_url: "#"
  };

  const eventSummary = {
  id: eventData.id, // Add the event ID
  title,
  datetime,
  venue: safeVenue,
  image: images[0],
  seatingPlan: seatingPlan
};
sessionStorage.setItem("selectedEvent", JSON.stringify(eventSummary));

  return (
    <>
    <section className="eventdetail-banner py-5 position-relative"  
    style={{
    backgroundImage: `
      url(${eventBannerBg}), 
      url(${images[0]})
    `,
    backgroundSize: 'cover',
    backgroundPosition: 'inherit',
    backgroundRepeat: 'no-repeat',
  }}>
       <div className="blur-overlay"></div>
      <div className="container-fluid  container-xxl px-md-5 py-4">
        {/* Header Section */}
        <div className="row gy-5">
          <div className="col-md-6">
            <div className="row">
              {/* <div className="col-7">
                <img src={images[0]} className="img-fluid rounded mb-2 w-100 h-100" alt="Main Banner" />
              </div> */}
              <div className="col-12">
                <img src={images[0]} className="img-fluid rounded mb-2" alt="Main Banner" />
              </div>
              {/* <div className="col-5">
  <div className="d-flex gap-3 flex-column">
    {images.slice(1, 3).map((img, idx) => (
      <div key={idx} className="position-relative">
        <img src={img} className="img-thumbnail w-100" alt={`Gallery ${idx}`} />
        {idx === 1 && (
          <div
            className="position-absolute bottom-0 end-0 p-2 bg-white rounded text-center view-gallery"
            style={{
              boxShadow: '0 0 10px rgba(0,0,0,0.3)',
              zIndex: 1,
              marginBottom: '10px',
              marginRight: '10px',
            }}
           onClick={openGallery}
          >
            <span><img src={photoGalleryIcon} alt="photo-gallery" class="img-fluid pe-2" /> View {images.length} Photos</span>
          </div>
        )}
      </div>
    ))}
  </div>
</div> */}
            </div>
          </div>
          <div className="col-md-6 px-md-5 d-flex flex-column event-details-rhs">
            <div>
              <h1 className='text-white event-title'>{title}</h1>
              <p className="text-white event-desc">{truncateText(stripHtmlTags(description))}</p>
              <p className='text-white d-flex align-items-center'>
                <img src={calendarIcon} alt="calendar-icon" class="img-fluid pe-2"/> 
                {formatEventDateTimeFromAPI(eventData.date, eventData.time)}
              </p>
              <p className='text-white d-flex align-items-center'>
                 <img src={locationIcon} alt="location-icon" class="img-fluid pe-2"/> {safeVenue.name}
              </p>
            </div>
            <div className=''>
              {isEventOver(datetime, eventData.date) ? (
                <div className="text-center w-75 mt-5">
                  <button className="btn btn-secondary btn-lg w-100" disabled>
                    Event Ended
                  </button>
                  <p className="text-white-50 mt-2 mb-0 small">This event has already taken place</p>
                </div>
              ) : (
                <Link
                  to={`/booking/${eventName}`}
                  state={{
                    id: eventData.id, // Add the event ID
                    title,
                    datetime,
                    venue: safeVenue,
                    image: images[0], // main image
                    seatingPlan: seatingPlan
                  }}
                  className="btn btn-primary btn-lg w-75 mt-5"
                >
                  Book Tickets
                </Link>
              )}
              {/* <p className="text-white text-center mt-2 w-75">Tickets Starting From £ {Math.min(...Object.values(ticketPrices))}</p> */}
            </div>
          </div>
        </div>
        </div>
    </section>
    {/* <section className='container-fluid'>
{(title.includes('pranayanila') || title.includes('pranayanila 2.0')) && (
  <div className="sponser-wrapper">
    <img height={80} src={shah} alt="sponsor" />
    <img height={80} src={lifespon} alt="sponsor" />
  </div>
)}
</section> */}


    <section className="container-fluid container-xxl px-md-5 my-5 about-event">
        {/* About Event */}
        <div className="row pb-5">
          <div className="col-md-7 pe-md-5">
   <div className="mb-5 pe-md-5">
          <h4>About the Event</h4>
          {formatDescription(description)}
        </div>

        {/* Guide & Layout */}
        <div className="row event-guide-layout pe-md-5">
          {/* Guide */}
          <div className="col-md-12 mb-4 pe-md-5">
            <h4>Event Guide</h4>
            <div className="d-flex gap-3 pt-3 justify-content-center">
              <div className="p-3 border rounded flex-fill d-flex align-items-center justify-content-center">
                <img src={hourglass} alt="hourglass" className="img-fluid pe-3" />

                <div>
 <p className='mb-0'>Duration</p>
                  <p className="fw-bold mb-0">{duration}</p>
                </div>
                 
              </div>
              <div className="p-3 border rounded flex-fill d-flex align-items-center justify-content-center">
                <img src={profileIcon} alt="profile" className="img-fluid pe-3" />
                <div>
<p className='mb-0'>Age Limit</p>
              <p  className="fw-bold mb-0">
                {ageLimit}
                </p>
                </div>
                  

                </div>
              <div className="p-3 border rounded flex-fill d-flex align-items-center justify-content-center">
                <img src={pawicon} alt="paw" className="img-fluid pe-3" />
                <div>
 <p className='mb-0'>
                    Pet Friendly
                    </p>
                <p className="fw-bold mb-0">{petFriendly === "true" ? "Yes" : "No"}
                </p>
                </div>
                 
            </div>
          </div>
          </div>

        {/* Venue */}



        
        </div>
          </div>

          <div className="col-md-5 ps-md-5">
            {isFiestaEvent(title) && (
              <video 
                ref={videoRef}
                className="img-fluid pb-4 w-100 mb-4" 
                controls 
                autoPlay 
                muted 
                loop
                playsInline
              >
                <source src={eventVideo} type="video/mp4" />
              </video>
            )}
          <div className="mt-4 event-venue">
  <h4 className="mb-3">Venue</h4>

  <div className="d-flex justify-content-between align-items-center flex-wrap">
    <div className="d-flex align-items-start">
      <img src={pinkLocation} alt="location-icon" className="img-fluid pe-3 mt-1" />
      <div>
        <p className="venue-name mb-1">{safeVenue.name}</p>
        <p className="venue-address mb-0">{safeVenue.address}</p>
      </div>
    </div>

  
  
   

  </div>

  <div className="d-flex gap-2 pt-4 pb-3">
     
     <a
       href={safeVenue.map_url}
       target="_blank"
       rel="noopener noreferrer"
       className="btn btn-secondary text-pink border-pink"
     >
       View Map
     </a>
   </div>

  <div className="d-flex gap-4 align-items-center pick-seats pb-4">
   
 
    {isEventOver(datetime, eventData.date) ? (
      <button className="btn btn-secondary mt-5" disabled>
        Event Ended
      </button>
    ) : (
      <Link
        to={`/booking/${eventName}`}
        state={{
          id: eventData.id, // Add the event ID
          title,
          datetime,
          venue: safeVenue,
          image: images[0], // main image
          seatingPlan: seatingPlan
        }}
        className="btn btn-primary mt-3 text-end"
      >
     Book your Seats
      </Link>
    )}
  </div>
  {/* <div className='mt-3'>
    <h6>Sponsored by:</h6>
  {showSponsors && (
  <div className="sponser-wrapper">
    <img className='me-4' width={80} src={shah} alt="sponsor" />
    <img className='me-4' width={140} src={lifespon} alt="sponsor" />
        <img className='me-4' width={100} src={adam} alt="sponsor" />
            <img className='me-4' width={140} src={bigbrix} alt="sponsor" />
                <img className='me-4' width={140} src={cs} alt="sponsor" />
                    <img className='me-4' width={100} src={gsl} alt="sponsor" />
                        <img className='me-4' width={100} src={green} alt="sponsor" />
                            <img className='me-4' width={100} src={legend} alt="sponsor" />
                                <img className='me-4' width={100} src={prabaLogo} alt="sponsor" />
                                    <img className='me-4' width={100} src={prabhavisiting} alt="sponsor" />
                                        <img className='me-4' width={140} src={wl} alt="sponsor" />
  </div>
)}
</div> */}
  <div className='mt-5'>
      <p style={{ fontSize: '1rem' }}>For any queries regarding booking please WhatsApp/call :
         &nbsp; <a
        className=" mt-5 text-primary"
        style={{ fontSize: '1rem', textDecoration: 'none', cursor: 'pointer' }}
        onClick={() => setShowContactModal(true)}
      >
         Contact Us
      </a></p>
    </div>
</div>

          </div>
          <section className='mt-5'>
          <h3 className='text-center'>Sponsored By</h3>
 <div className="sponser-wrapper mx-auto" style={{    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',}}>
    <img className='mx-3' width={80} src={shah} alt="sponsor" />
    <img className='mx-3' width={140} src={lifespon} alt="sponsor" />
        <img className='mx-3' width={100} src={adam} alt="sponsor" />
            <img className='mx-3' width={140} src={bigbrix} alt="sponsor" />
                <img className='mx-3' width={140} src={cs} alt="sponsor" />
                    <img className='mx-3' width={100} src={gsl} alt="sponsor" />
                        <img className='mx-3' width={100} src={green} alt="sponsor" />
                            <img className='mx-3' width={100} src={legend} alt="sponsor" />
                                <img className='mx-3' width={100} src={prabaLogo} alt="sponsor" />
                                    <img className='mx-3' width={100} src={prabhavisiting} alt="sponsor" />
                                        <img className='mx-3' width={140} src={wl} alt="sponsor" />
  </div>
  </section>
          {/* <div className="col-md-5 ps-md-5">
          <div className=" p-4 rounded event-layout">
            <h4 className='pb-3'>Layout</h4>
            <img src={layoutImage} className="img-fluid pb-4 w-100 rounded mb-3" alt="Seat Layout" />
            <div className='row flex-column justify-content-center'>
              {Object.entries(ticketPrices).map(([section, price]) => (
                <div key={section} className="d-flex justify-content-between border me-3 p-4 ">
                  <strong>{section}</strong> <span>£ {price}</span>
                </div>
              ))}
            </div>
             <Link
  to={`/booking/${eventName}`}
  state={{
    title,
    datetime,
    venue,
    image: images[0], // main image
    seatingPlan: seatingPlan
  }}
  className="btn btn-primary mt-4 w-100"
>
 Pick your Seats
</Link>
          </div>
            </div> */}

        </div>
     

     

    </section>


     {/* <section className="container-fluid container-xxl px-md-5 my-5">
      <EventsSection title="More Shows you may like" />
    </section> */}

      {/* Contact Us Modal */}
      {showContactModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: '#00000080' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Contact Us</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowContactModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>For any queries regarding booking please WhatsApp/call:</p>
                <div className="d-flex justify-content-between gap-3">
                  <a
                    href="https://wa.me/447884874463"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    style={{ textDecoration: 'none', padding: '12px', flex: 1 }}
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className="me-2" style={{ fontSize: '1.5rem' }} />
                    <span>+44 7884874463</span>
                  </a>
                  <a
                    href="https://wa.me/447780068830"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    style={{ textDecoration: 'none', padding: '12px', flex: 1 }}
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className="me-2" style={{ fontSize: '1.5rem' }} />
                    <span>+44 7780068830</span>
                  </a>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowContactModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* LightGallery - Hidden until triggered */}
      <LightGallery
        onInit={(ref) => (galleryRef.current = ref.instance)}
        dynamic
        dynamicEl={images.map((img) => ({ src: img, thumb: img }))}
        plugins={[lgThumbnail, lgZoom]}
        mode="lg-fade"
      />

  </>
  );
};

export default EventDetailPage;
